module.exports = __webpack_public_path__ + "img/shogi_2021_pack_3_0002.1ee8bd9d.png";